import React from 'react';
import { ShieldCheckIcon, ClockIcon, CreditCardIcon } from 'lucide-react';
export function FinalCTA() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="bg-[#d0e4f7] text-gray-900 pt-10 md:pt-14 pb-6 px-4 border-t-4 border-blue-300" data-id="element-101">
      <div className="max-w-4xl mx-auto text-center" data-id="element-102">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold mb-4 leading-tight" data-id="element-103">
          ¿Lista/o para estimular el aprendizaje de tu hijo/a?
        </h2>

        <p className="text-base md:text-lg text-gray-600 mb-8 max-w-2xl mx-auto font-medium" data-id="element-104">
          "Aprovechá la oferta de hoy y empezá a compartir momentos de calidad y
          aprendizaje lejos de las pantallas."
        </p>

        <a href="https://payments.vantapro.shop/cart/45305094963302:1" target="_blank" rel="noopener noreferrer" className="bg-orange-500 hover:bg-orange-600 text-white text-lg md:text-xl font-black py-4 px-6 rounded-full shadow-[0_0_20px_rgba(249,115,22,0.5)] transition-all duration-200 uppercase w-full max-w-xl mx-auto block mb-8 btn-pulse text-center" data-id="element-105">
          🏆 ACCEDER AHORA AL KIT COMPLETO + EXTRAS
        </a>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 mb-12" data-id="element-106">
          <div className="flex items-center gap-2 text-gray-600" data-id="element-107">
            <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-108" />
            <span className="font-medium text-sm" data-id="element-109">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2 text-gray-600" data-id="element-110">
            <ClockIcon className="w-5 h-5 text-blue-500" data-id="element-111" />
            <span className="font-medium text-sm" data-id="element-112">
              Acceso inmediato por Drive
            </span>
          </div>
          <div className="flex items-center gap-2 text-gray-600" data-id="element-113">
            <ShieldCheckIcon className="w-5 h-5 text-yellow-500" data-id="element-114" />
            <span className="font-medium text-sm" data-id="element-115">Garantía 7 días</span>
          </div>
        </div>

        <div className="border-t border-blue-200 pt-6 text-xs text-gray-500 max-w-3xl mx-auto leading-relaxed" data-id="element-116">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK
        </div>
      </div>
    </footer>;
}